import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)           // 懒加载
  .use(LanguageDetector)      // 语言检测
  .use(initReactI18next)      // React 集成
  .init({
    // 默认语言
    fallbackLng: 'zh-CN',
    
    // 支持的语言列表（包含简写形式作为别名）
    supportedLngs: ['zh-CN', 'zh', 'en-US', 'en', 'ja-JP', 'ja', 'ko-KR', 'ko', 'zh-TW', 'de-DE', 'de', 'fr-FR', 'fr'],
    
    // 命名空间
    ns: ['common', 'login', 'chat', 'csLogin'],
    defaultNS: 'common',
    
    // 插值配置
    interpolation: {
      escapeValue: false,  // React 已处理 XSS
    },
    
    // 语言包加载配置
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    // 语言检测配置
    // 优先级：querystring > navigator > localStorage
    detection: {
      order: ['querystring', 'navigator', 'localStorage'],
      
      // URL 参数名称
      lookupQuerystring: 'lang',
      
      // localStorage 存储键名
      lookupLocalStorage: 'i18nextLng',
      
      // 缓存到 localStorage
      caches: ['localStorage'],
      
      // URL 参数不缓存，每次重新读取（确保 App 参数优先）
      excludeCacheFor: ['querystring'],
      
      // 将简写语言代码转换为完整形式
      convertDetectedLanguage: (lng: string) => {
        // 统一转换：en_US -> en-US, zh_CN -> zh-CN 等
        const normalized = lng.replace('_', '-');
        
        // 语言映射：zh -> zh-CN, en -> en-US 等
        const mapping: Record<string, string> = {
          'zh': 'zh-CN',
          'en': 'en-US',
          'ja': 'ja-JP',
          'ko': 'ko-KR',
          'de': 'de-DE',
          'fr': 'fr-FR',
        };
        return mapping[normalized] || normalized;
      },
    },
    
    // 开发模式配置
    debug: import.meta.env.DEV,
    
    // 翻译完整性检查（开发环境启用）
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (lng: string[], ns: string, key: string) => {
      console.warn(`[i18n] 缺失翻译: ${lng}/${ns}/${key}`);
    },
  });

export default i18n;